const getters = {
  permission_routes: state => state.permission.routes,
  roles: state => state.user.roles,
  sidebar: state => state.app.sidebar,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
}
export default getters
